import axios, { AxiosError } from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const apiService = axios.create({
  baseURL: API_BASE_URL,
});

export const getAllProductsAPICall = async (payload: any) => {
    try {
      const response = await apiService.post("get-shop-products", payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  export const getRangeForPagination = async () => {
    try {
      const respones = await apiService.get("/price-page-range-data");
      return respones.data;
    } catch (error) { 
        console.log(error)
    }
  };